export const NetworkContextName = 'NETWORK';
export const EthAddress = '0xEeeeeEeeeEeEeeEeEeEeeEEEeeeeEeeeeeeeEEeE';
export const daiAddress = '0x6b175474e89094c44da98b954eedeac495271d0f';

export const supportedYearnTokens = ['yvusdc', 'yvdai', 'yvsteth'];
export const supportedCurveTokens = [];
